import http from '../config/http_ondeestatrem';

export const getEstacoesDisponiveis = () => {
    return http(false).get('/v1/EstacoesOrigemDestinoOperacional');
}


export default {
  getEstacoesDisponiveis
}